module.exports = __webpack_public_path__ + "media/images/icons/academic-development_01-5967a367e864f81a8614407e1d745b98.svg";